import { api } from '../creat-api'
/**
 * 通用设置
 * 转码模版接口
 **/
export function fetchTencentTemplate (params) {
  return api({
    url: '/TencentTemplate',
    params
  })
}
// 通用分类列表
export function fetchCommonCategory (params) {
  return api({
    url: '/commonCategory',
    params
  })
}
/**
 * 选择分类
 **/
export function fetchCheckCategory (params) {
  return api({
    method: 'PUT',
    url: '/commonCategory/checkCategory',
    data: params
  })
}

/**
 * 策略配置列表
 **/
export function fetchStrategySetting (params) {
  return api({
    url: '/strategySetting',
    params
  })
}

/**
 * 修改策略配置
 **/
export function fetchStrategySettingPut (params) {
  return api({
    method: 'PUT',
    url: '/strategySetting',
    data: params
  })
}
/**
 * 删除策略配置
 **/
export function fetchStrategySettingRm (params) {
  return api({
    method: 'DELETE',
    url: `/strategySetting/${params.id}?updateBy=${params.updateBy}`
  })
}
/**
 * 获取站点
 **/
export function fetchGetSiteAppsBySystemIds (params) {
  return api({
    url: '/siteApps/getSiteAppsBySystemIds',
    params
  })
}
/**
 * 添加策略配置
 **/
export function fetchStrategySettingAdd (params) {
  return api({
    method: 'POST',
    url: '/strategySetting',
    data: params
  })
}
